export default function original5() {
  console.log("The fifth original source");
}